import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { getAppName, HelpDocsService } from '@mode/shared/util-js';
import { ThoughtspotIntegrationService } from '@mode/shared/util-thoughtspot-integrated';

@Component({
  selector: 'mode-help-menu',
  templateUrl: './help-menu.component.html',
  styleUrls: ['./help-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HelpMenuComponent {
  @Input() isGuest = false;
  @Input() isCommunity = false;
  @Input() intercomChatEnabled = false;
  @Input() theme: 'light' | 'dark' = 'light';
  readonly appName = getAppName();

  public readonly isAnalystStudio$ = this.thoughtspotIntegrationService.currOrgIntegrated$;

  constructor(
    private thoughtspotIntegrationService: ThoughtspotIntegrationService,
    public helpDocs: HelpDocsService
  ) {}
}
